import { createSlice } from '@reduxjs/toolkit';
// eslint-disable-next-line import/no-cycle
import { AppThunk, RootState } from '../../store';

const workflowSlice = createSlice({
  name: 'workflow',
  initialState: {
    current: 0,
  },
  reducers: {
    next: (state) => {
      state.current += 1;
    },
    prev: (state) => {
      state.current -= 1;
    },
    resetPosition: (state) => {
      state.current = 0;
    },
  },
});

const prepareUploadState = (state) => {
  const { exchanges, upload } = state;

  let status = true
  exchanges.forEach((exchange) => {
    if (exchange.active && !upload[exchange.name]) {
      status = false
    }
  });

  return status;
};

export const { next, prev, resetPosition } = workflowSlice.actions;

export default workflowSlice.reducer;

export const selectCurrent = (state: RootState) => state.workflow.current;

export const selectUploadCompleteStatus = (state: RootState) =>
  prepareUploadState(state);

